import React                                from 'react';
import Matricula                            from '../pages/matricula/matricula';
import Pagina404                            from '../pages/pagina404';
import Paginasinpermiso                     from '../pages/paginasinpermiso';
import PagoLinea	                    from '../pages/caja/Alumno/Financiero/Pago_Linea'
import Suficienciaestudiante                from '../pages/suficiencia/suficiencia_estudiante';
import Mensajes                             from './Mensajes';
import Reporteparametros                    from '../pages/reportes/reporte_parametros';
import DiscusionCatedratico                 from '../pages/calificador/discusionCatedratico'  
import Cambios                              from '../pages/matricula/cambios'   
import CarrerasAlumno                       from '../pages/informacion/carreras_alumno'
import HorariosAlumno                       from '../pages/horarios/horariosalumno'
import HistoricoPagoAlumno                  from '../pages/financiero/historico_pagos_alumnos'
import EstadoCuentaAlumno                   from '../pages/financiero/estado_cuenta_alumno';
import Retiros                              from '../pages/matricula/retiros'
import Calificador                          from '../pages/calificador/calificador';
import Extraordinario                       from '../pages/financiero/extraordinario';
import DetallePagar                         from '../pages/financiero/detallePagar';
import TramitesAlumno                       from '../pages/financiero/tramites_alumno'; 
import CampanaISO                           from '../pages/listados catedratico/campañaISO'; 
import HistorialAlumno                      from '../pages/registro/Historicos_Academicos';
import PonderacionCatedratico               from '../pages/calificador/ponderacionCatedratico';
import ConsultaAsistenciasEstudiantes       from '../pages/registro/consultaAsistencias';
//JESSICA
import EstudiantesPreMatriculados           from '../pages/listados catedratico/EstudiantesPreMatriculados';
import EstudiantesMatriculados              from '../pages/listados catedratico/EstudiantesMatriculados'; 
import EstudiantesRetirados                 from '../pages/listados catedratico/EstudiantesRetirados';
import CambiarClave                         from '../pages/informacion/cambiar_clave';
import IntencionMatricula                   from '../pages/matricula/IntencionMatricula';

function Pagina(props) {
  
    const {pagina,...others} = props;
    var page_permiso=props.permisos_paginas
    
    if(page_permiso[pagina] !== undefined){

        var p = page_permiso[pagina]
        var l=p[1]; var e=p[2]; var i=p[3];

	if(props.reporte===true){
           return <Reporteparametros label_reporte={pagina} {...others} i={i} e={e} l={l}/>
    }
       
            var page_componente={
                Matricula:                                  	<Matricula     {...others} i={i} e={e} l={l}/>,
                Suficiencia_estudiante:                     	<Suficienciaestudiante {...others} i={i} e={e} l={l}/>,
		        DiscusionCatedratico:               		    <DiscusionCatedratico {...others} i={i} e={e} l={l}/>,
                Cambios:                                    <Cambios    {...others} i={i} e={e} l={l}/>,   
		        CarrerasAlumno:                             <CarrerasAlumno {...others} i={i} e={e} l={l} />,
		        HorariosAlumno:                             <HorariosAlumno {...others} i={i} e={e} l={l} />,
		        HistoricoPagoAlumno:                        <HistoricoPagoAlumno {...others} i={i} e={e} l={l} />,
			    EstadoCuentaAlumno:                         <EstadoCuentaAlumno {...others} i={i} e={e} l={l} />,
                Retiros:                                    <Retiros {...others} i={i} e={e} l={l} />, 
                Calificador:                                <Calificador {...others} i={i} e={e} l={l} />,
                Extraordinario:                             <Extraordinario {...others} i={i} e={e} l={l}/>, 
		        DetallePagar:                               <DetallePagar {...others} i={i} e={e} l={l} />,
		        TramitesAlumno:                             <TramitesAlumno {...others} i={i} e={e} l={l}/>,
		        CampanaISO:                                 <CampanaISO                         {...others} i={i} e={e} l={l}/>,
                Pago_Linea:		                            <PagoLinea    {...others} i={i} e={e} l={l}/>,    
		        ConsultaAsistenciasEstudiantes:	            <ConsultaAsistenciasEstudiantes {...others} i={i} e={e} l={l}/>,		   
                Historial_Alumno_estudiante:                <HistorialAlumno {...others} i={i} e={e} l={l}/>,
                PonderacionCatedratico:                     <PonderacionCatedratico {...others}/>,
                EstudiantesPreMatriculados:                  <EstudiantesPreMatriculados  {...others} i={i} e={e} l={l}/>,
                EstudiantesMatriculados:                     <EstudiantesMatriculados  {...others} i={i} e={e} l={l}/>,
                EstudiantesRetirados:                        <EstudiantesRetirados {...others} i={i} e={e} l={l}/>, 
                CambiarClave:                               <CambiarClave  {...others} i={i} e={e} l={l}/>,
                IntencionMatricula:                          <IntencionMatricula  {...others} i={i} e={e} l={l}/>,   
            }   
           
            if(page_componente[pagina]!==undefined){
                return(
		            <div>
                    {page_componente[pagina]}
                    {<Mensajes pagina={pagina}/>}
                    </div>
		);
            }
            else if(pagina!=='0'&&pagina!==undefined){
                return (<Pagina404 {...others}/>);
            }
            else
            return null
        }
        else
        {
            return(<Paginasinpermiso {...others}/>);
        }

};

export default function ObtenerPagina(props) {
    return (
            <Pagina {...props} />
    );  
}